const PaystackBase = require('./base')
class PaystackInterface {
  constructor (
    paystackSecrets,
    isomorphicFetch,
    logger
  ) {
    this.ke = new PaystackBase(
      paystackSecrets.ke,
      isomorphicFetch,
      logger
    )
    this.ng = new PaystackBase(
      paystackSecrets.ng,
      isomorphicFetch,
      logger
    )
  }

  getSecretKeys () {
    return {
      ng: this.ng.SECRET_KEY,
      ke: this.ke.SECRET_KEY
    }
  }
}

module.exports = PaystackInterface
